// Robust Notion API Service using Backend Proxy
const FEEDBACK_DATABASE_ID = '257e616c-482d-8026-8e40-000b332ed3ec';
const BACKEND_URL = 'http://localhost:5000';

console.log('NotionService: Using backend proxy for Notion API calls');
console.log('NotionService: Backend URL:', BACKEND_URL);

class NotionService {
  constructor() {
    console.log('NotionService: Constructor called');
    console.log('NotionService: Will use backend endpoint:', `${BACKEND_URL}/api/submit-feedback`);
  }

  async submitFeedback(feedbackData) {
    console.log('NotionService: submitFeedback called with:', feedbackData);
    
    try {
      console.log('NotionService: Submitting feedback through backend...');
      
      const response = await fetch(`${BACKEND_URL}/api/submit-feedback`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(feedbackData),
      });

      if (!response.ok) {
        const errorData = await response.text();
        throw new Error(`Backend API error: ${response.status} - ${errorData}`);
      }

      const result = await response.json();
      console.log('NotionService: Success! Response:', result);
      return { success: true, notionId: result.notionId };

    } catch (error) {
      console.error('NotionService: Error submitting feedback:', error);
      console.error('NotionService: Error details:', {
        name: error.name,
        message: error.message,
        stack: error.stack
      });
      
      // Fallback to localStorage if backend fails
      return this.storeFeedbackLocally(feedbackData);
    }
  }

  transformFeedbackForNotion(feedbackData) {
    const title = feedbackData.feedbackContent.substring(0, 100) + '...';
    
    return {
      parent: {
        database_id: FEEDBACK_DATABASE_ID
      },
      properties: {
        'Feedback Title': {
          title: [
            {
              text: {
                content: title
              }
            }
          ]
        },
        'Submitted By': {
          rich_text: [
            {
              text: {
                content: feedbackData.submittedBy
              }
            }
          ]
        },
        'User Email': {
          email: feedbackData.userEmail
        },
        'Feedback Content': {
          rich_text: [
            {
              text: {
                content: feedbackData.feedbackContent
              }
            }
          ]
        },
        'Submitted Date': {
          date: {
            start: feedbackData.submittedDate
          }
        }
      }
    };
  }

  storeFeedbackLocally(feedbackData) {
    try {
      const existingFeedback = JSON.parse(localStorage.getItem('userFeedback') || '[]');
      existingFeedback.push({
        ...feedbackData,
        storedLocally: true,
        timestamp: new Date().toISOString()
      });
      localStorage.setItem('userFeedback', JSON.stringify(existingFeedback));
      
      console.log('NotionService: Feedback stored locally:', feedbackData);
      return { success: true, storedLocally: true };
    } catch (error) {
      console.error('NotionService: Error storing locally:', error);
      return { success: false, error: error.message };
    }
  }

  async addEmailToDatabase(email) {
    try {
      const existingEmails = JSON.parse(localStorage.getItem('demoEmails') || '[]');
      existingEmails.push({
        email,
        timestamp: new Date().toISOString(),
        storedLocally: true
      });
      localStorage.setItem('demoEmails', JSON.stringify(existingEmails));
      
      console.log('NotionService: Email stored locally:', email);
      return { success: true, data: { email, timestamp: new Date().toISOString() } };
    } catch (error) {
      console.error('NotionService: Error storing email locally:', error);
      throw error;
    }
  }
}

const notionService = new NotionService();
console.log('NotionService: Instance created:', notionService);

export default notionService;
